import React, { useEffect, useState } from 'react';
import AddItemSubCategoryModal  from '../../components/Configs/AddItemSubCategoryModal';
import EditItemSubCategoryModal  from '../../components/Configs/EditItemSubCategoryModal';
import { Row, Col, Button, Table, Badge, Form } from 'react-bootstrap';
import {  toast } from 'react-toastify';

import { getCategories } from '../../services/Configs/ItemCategoriesService'; 
import { getAllSubCategories } from '../../services/Configs/ItemSubCategoriesService'

function ItemSubCategories(){ 
    const [subCategories, setSubCategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
    const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
    const [reload, setReload] = useState(false);
    const [selectedItemCategoryId, setSelectedItemCategoryId] = useState(0);
    const [selectedItemSubCategoryId, setSelectedItemSubCategoryId] = useState(0);
    const handleChangeDd = (e) => {
        const { value } = e.target;
        setSelectedItemCategoryId(value)
    }
    const handleAddCategory = () => {
        if(selectedItemCategoryId == 0)
        {
            toast.warning(`Es necesario seleccionar alguna categoría primero`)
        }
        else
        {
            setShowAddCategoryModal(true);
        }
    }
    const handleOpenEditModal = (id) => {
        setSelectedItemSubCategoryId(id);
        setShowEditCategoryModal(true);
    }

    useEffect(() => {
        getCategories().then(list => {
            setCategories(list);
        })
        getAllSubCategories(selectedItemCategoryId).then(subCategoriesList => {
            setSubCategories(subCategoriesList);
        })
    },[reload, selectedItemCategoryId])
    return (
        <>        
        <Row>
            <Col xl={3} className='text-center'>
            <Form.Group controlId="formRole">
                            <Form.Control
                                as="select"
                                name="categoryId"
                                onChange={handleChangeDd}
                            >
                                <option key={0} value={0}>Todas las categorías</option>
                                {categories.map((category) => (
                                        category.isActive ? 
                                        <option key={category.id} value={category.id}>{category.name}</option> :
                                        null
                                ))}
                            </Form.Control>
                        </Form.Group>
            </Col>
            <Col xl={3}>
                <Button variant='info' onClick={handleAddCategory} >Agregar</Button>
            </Col>
        </Row>
    
                    { 
                        subCategories.length == 0 ? (
                            <Row >
                                <Col xl={12} className='text-center' >
                                    <h4>No hay Subcategorías</h4>
                                </Col>
                            </Row>
                        ) :
                        <Row>
                            <Col xl={12}>
                                <Table className='mb-5 mt-3' striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th className='text-center'>
                                                Opciones
                                            </th>
                                            <th className='text-center'>
                                                Categoría
                                            </th>
                                            <th className='text-center'>
                                                Nombre
                                            </th>
                                            <th className='text-center'>
                                                Estatus
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    { subCategories.map((item, index) => (
                                            
                                            <tr key={index} >
                                                <td className='text-center'>
                                                    <Button variant='secondary' onClick={() => {handleOpenEditModal(item.id)}} >...</Button>
                                                </td>
                                                <td className='text-center'>
                                                    {item.sCategory.name}
                                                </td>
                                                <td className='text-center'>
                                                    {item.name}
                                                </td>
                                                <td className='text-center'>
                                                {item.isActive ?   <Badge bg="success">Activa</Badge> : <Badge bg="danger">Inactiva</Badge>  }
                                                </td>
                                            </tr>
                                        ))
                                    }
                                        </tbody>
                                </Table>     
                            </ Col>
                        </Row>
                }
                   
        <AddItemSubCategoryModal
        show={showAddCategoryModal}
        handleClose={() => setShowAddCategoryModal(false)}
        handleReload={() => { setReload(!reload) }}
        categoryId={selectedItemCategoryId}
         />
        <EditItemSubCategoryModal
        subcategoryId={selectedItemSubCategoryId}
        show={showEditCategoryModal}
        handleClose={() => setShowEditCategoryModal(false)}
        handleReload={() => { setReload(!reload) }}
         />
        
         </> 
    )
}
export default ItemSubCategories